import { Checkbox, MenuItem, MenuItemProps } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { forwardRef, Ref } from 'react';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

type Props = MenuItemProps & { label: string; checked?: boolean };

export const WbCheckboxMenuItem = forwardRef(
  (
    { label, checked, button, ...props }: Props,
    ref?: Ref<HTMLInputElement>,
  ) => {
    return (
      <MenuItem {...props} innerRef={ref}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={checked}
        />

        {label}
      </MenuItem>
    );
  },
);
